'use client';
import Link from 'next/link';
import { FC } from 'react';
import styles from './fbt-content-item.module.scss';
import { useFbtMobileDrawer } from '../fbt-mobile-drawer-context';
import { useSelectItemEvent } from 'hooks/analytics/use-select-item-event';
import { getFormattedSearchSelectItemHeadless } from 'components/product-comparison-grid/product-comparison-card/utils';
import { useFbtContext } from '../../fbt-context/fbt-context-provider';
import { getItemByPartNumber } from '../../utils';
import { FBT_LIST_NAME } from '../../../../constants/constants';

interface FbtCardTitleMobileProps {
  partNumber: string;
  name: string;
  isCurrentItem?: boolean;
  storeLocationId: string;
  startIndex: number;
}

const FbtCardTitleMobile: FC<FbtCardTitleMobileProps> = ({
  partNumber,
  name,
  isCurrentItem = false,
  storeLocationId,
  startIndex
}) => {
  const { closeDrawer } = useFbtMobileDrawer();
  const { fireEvent: fireSelectItemEvent } = useSelectItemEvent();
  const { cartDetails, fbtProductsWithPrice, itemSummary } = useFbtContext();

  const cartId = cartDetails?.orderHeader?.orderId;

  const handleClick = (e) => {
    if (isCurrentItem) {
      e.preventDefault();
      closeDrawer();
    }
    const partPrice = getItemByPartNumber(partNumber, fbtProductsWithPrice);
    const selectedSummary = getItemByPartNumber(
      partNumber,
      itemSummary?.products
    );

    fireSelectItemEvent({
      item: getFormattedSearchSelectItemHeadless(
        { orderItemId: cartId },
        partPrice
      ),
      partName: `${partNumber}: ${name}`,
      locationId: storeLocationId,
      itemSummary: {
        categoryPath: selectedSummary?.categoryPath,
        manufacturer: selectedSummary?.manufacturer ?? 'Cat'
      },
      isSearchPageEvent: true,
      itemListId: FBT_LIST_NAME,
      itemListName: FBT_LIST_NAME,
      serialNumber: '',
      fitment: '',
      index: startIndex
    });
  };

  return (
    <Link
      href={partNumber}
      className={`text-decoration-underline ${styles['fbt-content__title']}`}
      onClick={handleClick}
    >
      {`${partNumber}: ${name}`}
    </Link>
  );
};
export default FbtCardTitleMobile;
